import { render, staticRenderFns } from "./SurveyCriteriaManagerDialog.vue?vue&type=template&id=29952dcc"
import script from "./SurveyCriteriaManagerDialog.vue?vue&type=script&lang=ts"
export * from "./SurveyCriteriaManagerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports